export const portalData = {
    // Fax Details
    hasFax: false,
    faxNo: "",
    
    // Whatsapp details
    hasWhatsApp: true,
    whatsAppNo: "+6012 772 9880",
    whatsAppNoHolderName: "Trace Lai",
    hasAltWhatsApp: false,
    altWhatsAppNo: "",
    altWhatsAppNoHolderName: "",
    hasAltWhatsApp1: false,
    altWhatsAppNo1: "",
    altWhatsAppNoHolderName1: "",
    hasAltWhatsApp2: false,
    altWhatsAppNo2: "",
    altWhatsAppNoHolderName2: false,
    
    // Phone number details
    hasPhoneNo: true,
    phoneNo: true,
    phoneNo: "09 - 419 7788",
    hasAltPhoneNo: true,
    altPhoneNo: true,
  
  // Telephone number details
  hasTellNo: true,
  tellNo: "012 - 772 9880",
  tellNoHolderName: "Trace Lai",
  hasAltTellNo: true,
  altTellNo: "014 354 1593",
  altTellNoHolderName: "Trace Lai",
  hasAltTellNo2: false,
  altTellNo2: "",
  altTellNoHolderName2: "",
  
  // Portal information details
  portalNameXSpace: "Aman Tioman Beach Resort",
  portalName: "Aman Tioman Beach Resort",
  portalFullName: "Aman Holiday Sdn Bhd",
  portalFullNameUppercase: "AMAN HOLIDAY SDN BHD",
  portalShortAddress: "Lot 73, Kampung Paya",
  portalAddress: "Lot 73, Kampung Paya, Pulau Tioman, 26800 Pahang Darul Makmur",
  portalAddressFirstPart: "Lot 73, Kampung Paya, Pulau Tioman,",
  portalAddressSecondPart: "26800 Pahang Darul Makmur",
  portalAddressDetails: "Lot 73, Kampung Paya, Pulau Tioman, 26800 Pahang Darul Makmur",
  hasPortalRegNo: false,
  portalRegNo: "",
  
  // Portal Bank Details
  portalBankName: "Hong Leong Bank Berhad",
  portalBankAddress: "Lot 34 Jalan Delima 1/3 Taman Perindustrian Subang HI Tech 40000 Shah Alam",
  portalBankAccHolderName: "Aman Holiday Sdn Bhd",
  portalBankAccNo: "35600159428",
  hasPortalBankSwiftCode: true,
  portalBankSwiftCode: "HLBBMYKLXXX",
   
  portalEmail: "sales@amantioman.com",
  portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,
  
  appName: "Amantioman Digital Intelligence Platform (SBDIP)",

  // GST details
  hasGst: false,
  gstNo: true,
   
  // Website
  portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
 
  // Travoxis Website
  travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
 
  // Facebook page link
  facebookMessengerLink: "https://www.facebook.com/amantiomansales",
 
  // portal S3 base url
  s3AwsUrl: "",
 
  adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,

  // Portal Jetty names
  jettyOne: "Mersing Jetty",
  jettyTwo: "Jetty Paya",
  jettyThree: "",
  jettyOneToTwoTime: "11:00 AM",
  jettyTwoToOneTime: "09:30 AM",
  portalAdminUrl: "https://sg-admin.amantioman.com"
}